// Jobs on the vessel's Dashboard and phone Today (Service package): today, overdue, waiting for the owner, new requests, to confirm. One tap opens the job.
// No package: nothing is read and nothing is drawn. Nothing to show: nothing is drawn.
import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'
import { expiryToday } from '../lib/expiry'
import { todayView, dayLabel } from './core'
import { S, Status, Count } from './ui'

export function jobsCardModel(jobs, today, { crew = false } = {}) {
  const t = todayView({ jobs, today })
  return { today: t.today, overdue: t.overdue, waiting: t.waiting.length, requests: t.requests.length, confirm: crew ? jobs.filter(j => j.status === 'Done' && !j.onboard_confirmed_at).length : 0 }
}
export default function VesselJobsCard({ config, crew, onOpen }) {
  const on = !!(config && config.service && config.service.on), id = config && config.id
  const [jobs, setJobs] = useState(null)
  useEffect(() => {
    if (!on || !id) return
    let live = true
    supabase.from(crew ? 'work_orders_crew' : 'work_orders').select('id,client_id,title,status,scheduled_date,technician_name,source,onboard_confirmed_at,vessel_name').eq('client_id', id).limit(500)
      .then(({ data }) => { if (live) setJobs(data || []) }).catch(() => {})
    return () => { live = false }
  }, [on, id, crew])
  if (!on || !jobs) return null
  const m = jobsCardModel(jobs, expiryToday(config.timezone), { crew })
  const rows = [...m.overdue, ...m.today].slice(0, 4)
  if (!rows.length && !m.waiting && !m.requests && !m.confirm) return null
  const open = job => { try { if (job) localStorage.setItem('hc_open_job', job.id) } catch (e) {} onOpen && onOpen() }
  const chips = [m.waiting ? m.waiting + ' waiting for owner' : '', m.requests ? m.requests + ' new request' + (m.requests === 1 ? '' : 's') : '', m.confirm ? m.confirm + ' to confirm on board' : ''].filter(Boolean)
  return (
    <section style={{ ...S.card, marginBottom: 14 }} data-service="vessel-jobs" aria-label="Jobs">
      <div style={{ ...S.h, justifyContent: 'space-between' }}>
        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>Jobs {m.overdue.length > 0 && <Count n={m.overdue.length + ' overdue'} tone="#c0434a" />}</span>
        <button style={{ ...S.ghost, padding: '4px 10px', fontSize: 12 }} onClick={() => open(null)}>Open jobs</button>
      </div>
      {rows.map(j => (
        <div key={j.id} style={{ ...S.row, cursor: 'pointer' }} onClick={() => open(j)}>
          <div style={{ flex: 1, minWidth: 150 }}><div style={{ fontSize: 13.5, fontWeight: 600 }}>{j.title}</div><div style={S.muted}>{dayLabel(j.scheduled_date)} · {j.technician_name || 'No technician yet'}</div></div>
          <Status s={j.status} />
        </div>
      ))}
      {chips.length > 0 && <div style={{ ...S.muted, marginTop: rows.length ? 8 : 0 }}>{chips.join(' · ')}</div>}
    </section>
  )
}
